module.exports = __webpack_public_path__ + "static/media/sketching1.5a957740.jpg";